<script lang="ts" setup>
import { useFormStore } from "@stores/form.store"
import { computed } from "vue"

const { snapshot } = useFormStore()

type Props = {
    steps: {
        title: string
        progress: number
    }[]
}

const props = withDefaults(defineProps<Props>(), {
    steps: () => [],
})

function getColorIcon(progress: number) {
    return progress === 100 ? "#A1EC7E" : "#E3E3E3"
}
function getColorProgress(progress: number) {
    return progress === 100 ? "#A1EC7E" : "#1D6EE7"
}

const getCurrentStep = computed(() => {
    if (snapshot.value.context.step === 3) {
        return {
            title: "Envoyé !",
            progress: 100,
        }
    }

    return (
        props.steps[snapshot.value.context.step] || {
            title: "",
            progress: 0,
        }
    )
})
</script>
<template>
    <div class="form-stepper-mobile">
        <div class="form-stepper-mobile__items">
            <div
                class="form-stepper-mobile__item"
                v-for="(step, index) in steps"
                :key="index"
            >
                <h5>
                    Étape {{ index + 1 }}
                    <BaseIcon
                        icon="pi pi-check-circle"
                        :style="{ color: getColorIcon(step.progress) }"
                    />
                </h5>
            </div>
        </div>
        <h3
            class="text-primary-900 font-bold"
            :class="snapshot.context.step === 3 ? 'text-teal-500' : ''"
        >
            {{ getCurrentStep.title }}
        </h3>
        <div
            class="form-stepper-mobile__progress"
            :style="{
                '--progress': getCurrentStep.progress,
                '--color': getColorProgress(getCurrentStep.progress),
            }"
        ></div>
    </div>
</template>

<style scoped>
.form-stepper-mobile {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;

    .form-stepper-mobile__items {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 0.75rem;
        align-self: stretch;
    }

    .form-stepper-mobile__progress {
        position: relative;
        width: 100%;
        height: 1.5rem;
        background-color: #e3e3e3;
        border-radius: 0.125rem;

        &:before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: calc(100% * (var(--progress) / 100));
            height: 100%;
            background-color: var(--color);
            border-radius: 0.125rem;
        }
    }
}
</style>
